import { useSelector } from 'react-redux';
import { Networks, OfflineEventTriggers // @ts-expect-error importing from JS file
} from 'AdsUI/lib/Constants';
import { getFacebookCapiLCSEvents, getGoogleEnhancedConversionsLCSEvents // @ts-expect-error importing from JS file
} from 'AdsUI/selectors/AuthSelectors';

/**
 * The container for rendering the event creation button. The button is
 * customized for some form types.
 */
const EventCreationButtonContainer = ({
  currentEventTrigger,
  facebookCapiButton,
  googleECLCSButton,
  network,
  offlineEventButton
}) => {
  const hasFacebookCapiLCSEvents = useSelector(getFacebookCapiLCSEvents);
  const hasGoogleEnhancedConversionsLCSEvents = useSelector(getGoogleEnhancedConversionsLCSEvents); // Remove hasFacebookCapiLCSEvents check when cleaning up stale
  // Ads:FacebookCapiLifecycleStageEvents gate

  if (hasFacebookCapiLCSEvents && network === Networks.FACEBOOK && currentEventTrigger === OfflineEventTriggers.LIFECYCLE_STAGE_CHANGE) {
    return facebookCapiButton;
  } // Remove hasGoogleEnhancedConversionsLCSEvents check when cleaning up stale
  // Ads:GoogleECforLifecycleStageEvents gate


  if (hasGoogleEnhancedConversionsLCSEvents && network === Networks.ADWORDS && currentEventTrigger === OfflineEventTriggers.LIFECYCLE_STAGE_CHANGE) {
    return googleECLCSButton;
  }

  return offlineEventButton;
};

export default EventCreationButtonContainer;